export const allOperationsSelected = '';
export const farmerNavigationDefaultOperation = 'all-operations';
export const farmerNavigationStorageKeys = {
  'OPERATION_SELECTED': 'operation-selected'
} as const;
